import React from 'react';
import styled from 'styled-components';
import {
  Title,
  Wrapper,
  Card
} from '../../../ChangeStudiesOption/info/components';
import WhiteContainer from '@/presentation/modules/procedures/components/ContainerProcedure/WhiteContainer';
import Link from '@/presentation/reusables/Link';

const ProcedureInformationText = styled.div`
  ul {
    list-style: disc;
    margin-left: 24px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }
`;

interface ProcedureInfoComponentProps {
  inRegister?: boolean;
}
const ProcedureInfoComponent = ({
  inRegister
}: ProcedureInfoComponentProps) => (
  <WhiteContainer inRegister={inRegister}>
    <Wrapper>
      <Card>
        <Title>Información del trámite:</Title>
        <div style={{ marginBottom: '16px' }}>
          <ProcedureInformationText>
            <ul>
              <li>
                El costo de cambio de campus y/o carrera es de S/175.00. Si
                realizas un cambio se te exonera el pago de la reincorporación.
              </li>
              <li>
                El estudiante reincorporado se somete íntegra e
                incondicionalmente al contenido, condiciones y equivalencias del
                plan de estudios al que se reincorpora, así como a la pensión de
                estudios vigente y a todas las normas vigentes al momento de su
                reincorporación (Art. 46 del Reglamento de Estudios).
              </li>
              <li>
                Revisa el{' '}
                <Link
                  linkType="external"
                  url="https://view.genially.com/682f5cb3e4686e4a7c50cd38"
                  linkName="cronograma de reincorporación."
                />
              </li>
            </ul>
          </ProcedureInformationText>
        </div>
      </Card>
      <Card>
        <Title>¿Qué requisitos necesito?</Title>
        <div style={{ marginBottom: '8px' }}>
          <ProcedureInformationText>
            <ul>
              <li>No tener deudas pendientes.</li>
              <li>
                No estar suspendido por desaprobar una o más asignaturas por
                tercera vez.
              </li>
              <li>
                No haber desaprobado una o más asignaturas por cuarta vez.
              </li>
              <li>No estar suspendido por medidas disciplinarias.</li>
              <li>
                No tener documentación pendiente de entrega del proceso de
                admisión.
              </li>
            </ul>
          </ProcedureInformationText>
        </div>
      </Card>
    </Wrapper>
  </WhiteContainer>
);

ProcedureInfoComponent.defaultProps = {
  inRegister: false
};

const StepsToFollowComponent = () => (
  <Card>
    <p>
      <strong>Pasos a seguir:</strong>
    </p>
    <div>
      <ul
        style={{
          listStyle: 'auto',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          color: '#161D1F',
          marginTop: '12px',
          marginLeft: '20px'
        }}
      >
        <li>Selecciona el ciclo al cual deseas reincorporarte.</li>
        <li>
          Realiza tus opciones de cambio: Modalidad, campus y carrera
          (opcional).
        </li>
        <li>Realiza el pago en nuestras opciones disponibles.</li>
      </ul>
    </div>
  </Card>
);

const ProcedureInfoData = ({ inRegister }: any) => (
  <>
    <ProcedureInfoComponent inRegister={inRegister} />
    <br />
    <WhiteContainer inRegister={false}>
      <Wrapper>
        <StepsToFollowComponent />
      </Wrapper>
    </WhiteContainer>
  </>
);

export { ProcedureInfoComponent, StepsToFollowComponent, ProcedureInfoData };
